{
  "repairCenterNotFoundError": "No repair center configuration matches this repair file.",
  "tooManyRepairCenterFoundError": "Several repair center configurations match this repair file. Contact an administrator.",
  "smsServiceUnavailableError": "SMS notifications are unavailable. Please try again later or choose another notification method.",
  "smsNotificationFailedError": "The SMS could not be sent. Please try again.",
  "accountNotFoundError": "Account not found",
  "expiredJwtError": "Session expired",
  "expiredLogin2faCodeError": "Verification code expired",
  "invalidAccountError": "Invalid account",
  "invalidBodyError": "Invalid request",
  "invalidCaptchaTokenError": "Invalid captcha",
  "invalidCsrfError": "Invalid session",
  "invalidEmailError": "Invalid email",
  "invalidJwtError": "Invalid session",
  "invalidLogin2faCodeError": "Invalid verification code",
  "invalidNetworkError": "Invalid network",
  "invalidNewConfirmPasswordError": "Passwords must match",
  "invalidPasswordError": "Invalid password",
  "invalidPhoneNumberError": "Invalid phone number",
  "invalidFirstnameError": "Invalid first name",
  "invalidLastnameError": "Invalid last name",
  "invalidJobDescriptionError": "Invalid job description",
  "invalidIdError": "Invalid identifier",
  "invalidStatusError": "Invalid status",
  "invalidTokenError": "Invalid token",
  "login2faAttemptLimitReachedError": "Attempt limit reached",
  "login2faRequiredError": "Two-step verification required",
  "login2faResendLimitReachedError": "Resend limit reached",
  "requestDraftNotEditableError": "This request has already been submitted and can no longer be edited.",
  "unexpectedError": "Unexpected error",
  "userAlreadyExistsError": "This collaborator already exists",
  "collaboratorNotFoundError": "Collaborator not found",
  "unknown": "Unexpected error"
}
